import { render, staticRenderFns } from "./CategoryCards.vue?vue&type=template&id=317d894d&"
import script from "./CategoryCards.vue?vue&type=script&lang=js&"
export * from "./CategoryCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports